import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaPencilAlt } from 'react-icons/fa';
import Logo from '../../assets/images/gurukullogo.png';
import { toast } from 'react-toastify';
import { generateOTP, verifyOTP } from '../../api/authApi';

import './ForgetPassword.css';

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [errors, setErrors] = useState({
    email: '',
    newPassword: '',
    confirmPassword: '',
    otp: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [resendTimer, setResendTimer] = useState(0);

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      email: '',
      newPassword: '',
      confirmPassword: '',
      otp: ''
    };

    if (!email) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Invalid email format';
      isValid = false;
    }

    if (!newPassword) {
      newErrors.newPassword = 'Password is required';
      isValid = false;
    } else if (newPassword.length < 6) {
      newErrors.newPassword = 'Password must be at least 6 characters';
      isValid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Confirm password is required';
      isValid = false;
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleCreatePassword = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      const response = await generateOTP(email, newPassword, confirmPassword);
      setIsLoading(false);

   
      if (response.statusCode === "INTERNAL_SERVER_ERROR") {
        toast.error('Finhaat snag Problem. Please try again.');
      } else {
        setShowOtpForm(true);
      }
    } catch (err) {
      console.error('Error generating OTP:', err);
      setIsLoading(false);

      
      if (err.response && err.response.status === 500) {
        toast.error('Please provide a valid email address.');
        console.log('Generating OTP: 500 Error');
      } else {
        
        setErrors(prev => ({
          ...prev,
          email: err.message
        }));
      }
    }
  };


  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    if (!otp) {
      setErrors(prev => ({
        ...prev,
        otp: 'OTP is required'
      }));
      return;
    }

    setIsLoading(true);
    try {
      const response = await verifyOTP(email, newPassword, confirmPassword, otp);
      setIsLoading(false);

     
      const status = response.status;

      if (status === "1") {
        toast.success('Password updated successfully!');
        navigate('/login', { replace: true });
      } else if (status === "2") {
        toast.error('Invalid OTP. Please try again.');
      } else {
        toast.error('An error occurred. Please try again.');
      }
    } catch (err) {
      console.error('Error verifying OTP:', err);
      setIsLoading(false);
      toast.error('An error occurred. Please try again.');
      setErrors(prev => ({
        ...prev,
        otp: err.message
      }));
    }
  };

  const handleResendOTP = async () => {
    if (resendTimer > 0) {
      return; 
    }
  
    setIsLoading(true);
  
    try {
     
      const response = await generateOTP(email, newPassword, confirmPassword); 
      if (response.statusCode === "INTERNAL_SERVER_ERROR") {
        toast.error('Failed to resend OTP. Please try again.');
      } else {
        toast.success('OTP sent successfully!');
        startResendCooldown(); 
      }
    } catch (err) {
      console.error('Error sending OTP:', err);
      toast.error('An error occurred while sending OTP. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  

  const startResendCooldown = () => {
    let countdown = 30; 
    setResendTimer(countdown);

    const timerInterval = setInterval(() => {
      countdown -= 1;
      setResendTimer(countdown);

      if (countdown === 0) {
        clearInterval(timerInterval); 
      }
    }, 1000); 
  };




  const handleEdit = () => {
    setShowOtpForm(false);
  };

  return (
    <div className="forget-password-container flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          alt="Logo"
          src={Logo}
          className="mx-auto logo-auth-sizes"
        />
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          {showOtpForm ? 'Enter OTP' : 'Forget Password'}
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        {!showOtpForm ? (
          <form onSubmit={handleCreatePassword} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-900">
                Email
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-500">{errors.email}</p>
                )}
              </div>
            </div>

            <div>
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-900">
                New Password
              </label>
              <div className="mt-2 relative flex items-center">
                <input
                  id="newPassword"
                  type={showPassword ? 'text' : 'password'}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="block w-full rounded-md border-0 py-1.5 px-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
                />
                <div className="absolute right-3 flex items-center">
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="text-gray-500 focus:outline-none"
                  >
                    {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                  </button>
                </div>
              </div>
              {errors.newPassword && (
                <p className="mt-1 text-sm text-red-500">{errors.newPassword}</p>
              )}
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-900">
                Confirm Password
              </label>
              <div className="mt-2 relative flex items-center">
                <input
                  id="confirmPassword"
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="block w-full rounded-md border-0 py-1.5 px-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
                />
                <div className="absolute right-3 flex items-center">
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="text-gray-500 focus:outline-none"
                  >
                    {showConfirmPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                  </button>
                </div>
              </div>
              {errors.confirmPassword && (
                <p className="mt-1 text-sm text-red-500">{errors.confirmPassword}</p>
              )}
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
            >
              {isLoading ? 'Creating password...' : 'Create Password'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerifyOTP} className="space-y-6">
            {/* Read-only Email and Password fields */}
            <div className="space-y-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-900">Email</label>
                <div className="mt-2 relative flex items-center">
                  <input
                    type="text"
                    value={email}
                    readOnly
                    className="block w-full rounded-md border-0 py-1.5 px-3 pr-10 text-gray-500 bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
                  />
                  <div className="absolute right-3 flex items-center">
                    <button
                      type="button"
                      onClick={handleEdit}
                      className="text-gray-500 hover:text-indigo-600 focus:outline-none"
                    >
                      <FaPencilAlt size={16} />
                    </button>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-900">Password</label>
                <div className="mt-2 relative flex items-center">
                  <input
                    type="password"
                    value="••••••••"
                    readOnly
                    className="block w-full rounded-md border-0 py-1.5 px-3 pr-10 text-gray-500 bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
                  />
                  <div className="absolute right-3 flex items-center">
                    <button
                      type="button"
                      onClick={handleEdit}
                      className="text-gray-500 hover:text-indigo-600 focus:outline-none"
                    >
                      <FaPencilAlt size={16} />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* OTP Input Fields */}
            <div className="flex space-x-2 justify-center">
              {Array.from({ length: 6 }).map((_, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  maxLength="1"
                  value={otp[index] || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[0-9]$/.test(value) || value === '') {
                      const newOtp = otp.split('');
                      newOtp[index] = value;
                      setOtp(newOtp.join(''));
                      if (value && index < 5) {
                        document.getElementById(`otp-${index + 1}`).focus();
                      }
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Backspace' && !otp[index]) {
                      if (index > 0) {
                        document.getElementById(`otp-${index - 1}`).focus();
                      }
                    }
                  }}
                  className="block w-12 rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 text-center"
                />
              ))}
            </div>

            <div className="mt-4 text-center">
             
              <button
                type="button"
                onClick={handleResendOTP}
                disabled={resendTimer > 0 || isLoading} 
                className="text-sm font-semibold text-indigo-600 hover:text-indigo-500 disabled:text-gray-400"
              >
                {resendTimer > 0 ? `Resend in ${resendTimer}s` : 'Resend OTP'}
              </button>
            </div>


            <button
              type="submit"
              disabled={isLoading}
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
            >
              {isLoading ? 'Verifying...' : 'Verify OTP'}
            </button>
          </form>
        )}

        <p className="mt-10 text-center text-sm text-gray-500">
          return to{' '}
          <Link to="/login" className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgetPassword;